export default "__VITE_ASSET__96cdc1af__"